<template>
  <component :is="iconComponent" />
</template>

<script>

import IconTicket from "@/components/icons/IconTicket.vue"
import IconAirPlain from "@/components/icons/IconAirPlain.vue"
import IconArrowRight from "@/components/icons/IconArrowRight.vue"
import IconBed from "@/components/icons/IconBed.vue"
import IconCar from "@/components/icons/IconCar.vue"
import IconDisney from "@/components/icons/IconDisney.vue"
import IconUniversal from "@/components/icons/IconUniversal.vue"
import IconShield from "@/components/icons/IconShield.vue"


export default {
  name: 'IconDashboard',
  components: {
    IconTicket,
    IconAirPlain,
    IconArrowRight,
    IconBed,
    IconCar,
    IconDisney,
    IconUniversal,
    IconShield
  },
  props: {
    iconName: {
      type: String,
      required: true
    }
  },
  computed: {
    iconComponent() {
      return this.iconName ? this.iconName : 'IconArrowRight'
    }
  }
}
</script>